import { createApp } from "vue";
import { enableKatex } from "markstream-vue";
import App from "./App.vue";
import router from "./router";
import { useAuth } from "./composables/useAuth";
import "./assets/styles.css";
import "katex/dist/katex.min.css";
import "markstream-vue/index.css";

enableKatex();

const { initUser } = useAuth();
initUser();

createApp(App).use(router).mount("#app");
